import { render, staticRenderFns } from "./SalesmanProfileView.vue?vue&type=template&id=21a1ed68&"
import script from "./SalesmanProfileView.vue?vue&type=script&lang=js&"
export * from "./SalesmanProfileView.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanProfileView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports